module.exports = __webpack_public_path__ + "img/hack-light.964b2e1c.png";